import * as React from "react";

import * as dates from "../../../reducers/changeTimePeriod";

import { IEvent } from "../../../classes/event";

export interface IMonthDayCellEventAnchor {
    allDayText: string;
    event: IEvent;
    eventText: string;
    monthStart: Date;
    onText: string;
    toText: string;
    date: Date;
    userDateFormat: string;
}

export const MonthDayCellEventAnchor = (props: IMonthDayCellEventAnchor) => {

    const event = props.event;

  const anchorId = event.anchorId;

    const extendsIntoLastMonth = dates.isBefore(event.localStartDate, props.monthStart) && dates.getDaysBetweenDates(props.date, props.monthStart) === 0;

    const dateRange = dates.eventDescription(event, props.allDayText);
    const screenReaderDateRange = dates.eventDescriptionMonthlyList_Screenreader(event, props.allDayText, props.onText, props.toText);

    const onClicked = (e) => { e.preventDefault(); };

    return (
        <a href="#!" id={anchorId} onClick={onClicked}>
            { /* Have to use dangerouslySetHTML because React inline style objects do not support !important. */}
            {event.color &&
                <style dangerouslySetInnerHTML={{ __html: `#${anchorId} { background: ${event.color} !important; }` }} />
            }
            <strong>
                {extendsIntoLastMonth &&
                    <span><em className="fa fa-arrow-left"></em> </span>
                }
                {event.icon &&
                    <img src={event.icon} aria-hidden="true" />
                }
                <span className="offScreen">{props.eventText} </span>{event.name}&nbsp;
            </strong>
            <em aria-hidden="true">{dateRange}</em>
            <span className="offScreen">{screenReaderDateRange}</span>
        </a>
    );
};
